module.exports = __webpack_public_path__ + "img/intro2.eafac8ea.jpeg";